import React, { useState } from 'react';
import { Button } from './ui/button';
import { BookOpen } from 'lucide-react';
import { GuidanceModal } from './GuidanceModal';
import type { Question } from '../types/question-bank';

interface GuidanceButtonProps {
  question: Question;
  className?: string;
}

export function GuidanceButton({ question, className }: GuidanceButtonProps) {
  const [open, setOpen] = useState(false);

  // Determine if we should show the button
  const hasEducation = !!question.education;
  // We only show for education. Simple helpText usually renders inline, but 
  // if we want to force it into a modal for "Review Mode" where space is tight, we could.
  // For now, let's stick to the "Education Payload" doctrine which implies rich content.
  // However, the prompt explicitly said "or even helpText".
  // So if no education but helpText exists, we can show it in the modal as a fallback.
  const hasContent = hasEducation || !!question.helpText;

  if (!hasContent) return null;

  return (
    <>
      <Button 
        variant="ghost" 
        size="sm" 
        className={`h-7 px-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50 shrink-0 ${className}`}
        onClick={() => setOpen(true)}
      >
        <BookOpen className="w-3.5 h-3.5 mr-1.5" />
        Learn more
      </Button>

      <GuidanceModal 
        open={open} 
        onOpenChange={setOpen} 
        question={question}
        education={question.education || (question.helpText ? {
            topicId: 'help',
            content: question.helpText,
            examples: [],
            clarification: '',
            whyItMatters: '',
            reassurance: ''
        } : undefined)}
      />
    </>
  );
}
